import { render } from "./PlatformAdmin.vue?vue&type=template&id=2dd9dab7&scoped=true"
import script from "./PlatformAdmin.vue?vue&type=script&lang=js"
export * from "./PlatformAdmin.vue?vue&type=script&lang=js"

import "./PlatformAdmin.vue?vue&type=style&index=0&id=2dd9dab7&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/SIMI-TRAC/SIMI-TRAC-PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2dd9dab7"]])

export default __exports__